export default __webpack_public_path__ + "static/media/Damaso_No17Open.f04d3c80.jpg";